import { addRestClientLogger, RestClient } from '@gem/modules/restClient';

import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';
import { getUserLanguage } from 'UTILS/getUserLanguage';

export const bffRestClient = new RestClient({
  baseUrl: `/api/v1`,
});

export const tenantRouterRestClient = new RestClient({
  baseUrl: `${ProjectUrls.routerUrl}/api/v1`,
  headers: {
    locale: getUserLanguage(),
    'Content-Type': 'application/x-protobuf',
    Accept: 'application/x-protobuf',
    credentials: 'include',
  },
});

tenantRouterRestClient.addRequestInterceptor((options) => ({
  ...options,
  useRawReqData: true,
}));

addRestClientLogger(bffRestClient);
addRestClientLogger(tenantRouterRestClient);
